import { Box, IconButton } from "@mui/material";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import WarningIcon from "@mui/icons-material/Warning";
import { useState } from "react";

export type DeleteButtonProps = {
  onClick: () => void;
  label: string;
};

export const DeleteButton = ({ onClick, label }: DeleteButtonProps) => (
  <IconButton onClick={onClick} title={label} color="error">
    <DeleteOutlinedIcon color="secondary" />
  </IconButton>
);

type RemoveModalProps = {
  title?: string;
  text?: string;
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => void;
};

export const RemoveModal = ({
  title = "Eliminar elemento",
  text = "Estás seguro de eliminar este elemento?",
  isOpen,
  onClose,
  onDelete,
}: RemoveModalProps) => {
  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent dividers>
        <Box
          display="flex"
          justifyContent="center"
          alignItems="center"
          marginBottom={2}
          sx={{ flexDirection: "column" }}
        >
          <WarningIcon color="warning" sx={{ fontSize: 35 }} />
          <Typography variant="body1" align="center">
            {text}
          </Typography>
        </Box>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" color="primary" onClick={onDelete}>
          {"Confirmar"}
        </Button>
        <Button variant="outlined" color="secondary" onClick={onClose}>
          {"Cancelar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export type CommonModalProps = {
  title?: string;
  text?: string;
};

type RemoveProps = CommonModalProps & {
  onRemove?: () => Promise<void> | void;
};

export function Remove({
  onRemove = async () => {},
  title,
  text,
}: RemoveProps) {
  const [show, setShow] = useState(false);

  const deleteElement = async () => {
    setShow(false);
    await onRemove();
  };

  const translatedTitle = title || "Eliminar elemento";
  const translatedText = text || "Estás seguro de eliminar este elemento?";

  return (
    <>
      <DeleteButton onClick={() => setShow(true)} label={"Eliminar"} />
      <RemoveModal
        title={translatedTitle}
        text={translatedText}
        isOpen={show}
        onClose={() => setShow(false)}
        onDelete={deleteElement}
      />
    </>
  );
}
